export default "__VITE_ASSET__c4eb093c__"